// src/App.jsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Login";
import RegisterForm from "./REgister"; 
import Usermanager from "./Usermanager";
import LuckyNo from "./LuckyNo";
import TypingGame from "./Typinggame";
import ColorGame from "./Colorgame";
import Mainpage from "./Mainpage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login/>} />
        <Route path="/register" element={<RegisterForm/>} />
        <Route path="/usermanager" element={<Usermanager/>}/>
          <Route path="/main" element={<Mainpage />} />
        <Route path="/guess" element={<LuckyNo />} />
        <Route path="/color" element={<ColorGame />} />
        <Route path="/typing" element={<TypingGame />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
